import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import {
  UncontrolledAccordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";


import Mp3Player from "../../components/Mp3Player/AudioPlayer";
import Recitation from "../../components/Receitation/Receitation";
import SectionTitle from "../../components/common/section-title";
import EnglishTranslation from "../../components/Translations/EnglishTranslation";
import Spinner from "../../components/Spinner/Spinner";

export default function QuoranComponent() {
  const { surahId } = useParams();
  const navigate = useNavigate();
  const printableRef = useRef();
  const [searchParams] = useSearchParams();

  const [surah, setSurah] = useState({});
  const [surahList, setSurahList] = useState([]);
  const [dropdownJump, setDropdownJump] = useState(false);
  const [activeTab, setActiveTab] = useState("transliteration");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([axios.get(`${process.env.REACT_APP_API_URL}/surah`), axios.get(`${process.env.REACT_APP_API_URL}/surah/${surahId}`)]).then(values => {
      setSurahList(values[0].data);
      setSurah(values[1].data);
      setIsLoading(false);
    }).catch(err => {
      console.log(err);
      setIsLoading(false);
    });
  }, [surahId]);

  const toggle = () => setDropdownJump((prevState) => !prevState);
  const navigateTo = (surahId) => {
    navigate(`/surah-list/${surahId}`)
  }

  if (isLoading) {
    return <div className="spinner-overlay"><Spinner /></div>
  }

  if (searchParams.get("printable")) {
    return (
      <Container className="mt-4">
        <div
          className="fade-in text-dark"
          dangerouslySetInnerHTML={{
            __html: surah.transliterationDescription,
          }}
        />
      </Container>
    )
  }

  return (
    <div className="mt-5" ref={printableRef}>
      <SectionTitle title={`Surah ${surahId} : ${surah.name}`} />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Dropdown isOpen={dropdownJump} toggle={toggle}>
          <DropdownToggle
            caret
            className="dropdown-surah"
          >
            Jump to{" "}
          </DropdownToggle>
          <DropdownMenu className="dropdown-surah-menu box-shadow">
            <DropdownItem header>Select Surah</DropdownItem>
            {surahList.map((data) => {
              const nameSplit = data.name.split("-");
              nameSplit.pop();
              return (
                <DropdownItem
                  key={data.id}
                  style={{ padding: 5, marginLeft: 5 }}
                  onClick={() => navigateTo(data.id)}
                >{`Surah ${data.id}: ${nameSplit.join("-")}`}</DropdownItem>
              );
            })}
          </DropdownMenu>
        </Dropdown>
      </div>

      <div className="mt-5">
        <Recitation />
      </div>

      <div className="mt-4">
        <Container>
          <Nav tabs fill>
            <NavItem>
              <NavLink
                active={activeTab === "transliteration"}
                onClick={() => setActiveTab("transliteration")}
                className="p2 custom-text"
              >
                TRANSLITERATION
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === "english"}
                onClick={() => setActiveTab("english")}
                className="p-2 custom-text"
              >
                ENGLISH
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                active={activeTab === "arabic"}
                onClick={() => setActiveTab("arabic")}
                className="p-2 custom-text"
              >
                ARABIC
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab} className="tab-background">
            <TabPane tabId="transliteration">
              <div className="text-muted list-unstyled mt-4 features-item-list">
                <div
                  className="fade-in text-dark"
                  dangerouslySetInnerHTML={{
                    __html: surah.transliterationDescription,
                  }}
                />
              </div>
            </TabPane>
            <TabPane tabId="english">
              <div className="text-muted list-unstyled mt-4 features-item-list fade-in">
                <EnglishTranslation />
              </div>
            </TabPane>
            <TabPane tabId="arabic">
              <div className="text-muted list-unstyled mt-4 features-item-list">
                <div
                  className="fade-in text-dark"
                  dangerouslySetInnerHTML={{
                    __html: surah.arabicDescription,
                  }}
                  style={{ textAlign: "right" }}
                />
              </div>
            </TabPane>
          </TabContent>
        </Container>
      </div>

      <div className="mt-4 mb-4">
        <Container>
          <UncontrolledAccordion defaultOpen={["1"]} stayOpen>
            <AccordionItem>
              <AccordionHeader targetId="1" className="custom-accordion-header">
                <span className="custom-text">Audio English</span>
              </AccordionHeader>
              <AccordionBody accordionId="1">
                <Mp3Player src={`${process.env.REACT_APP_AUDIO_ENGLISH_BASE_URL}${surah.audioEnglishUrl}`} />
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="2" className="custom-accordion-header">
                <span className="custom-text">Audio: Arabic English</span>
              </AccordionHeader>
              <AccordionBody accordionId="2">
                <Mp3Player src={`${process.env.REACT_APP_AUDIO_ARABIC_ENGLISH_BASE_URL}${surah.audioArabicEnglishUrl}`} />
              </AccordionBody>
            </AccordionItem>
            <AccordionItem>
              <AccordionHeader targetId="3" className="custom-accordion-header">
                <span className="custom-text">Tafseer</span>
              </AccordionHeader>
              <AccordionBody accordionId="3">
                <p
                  className="text-dark web-desc fade-in custom-desc"
                  dangerouslySetInnerHTML={{ __html: surah.tafseer }}
                />
              </AccordionBody>
            </AccordionItem>
          </UncontrolledAccordion>
        </Container>
      </div>
    </div>
  );
}
